import { useState } from "react";
import { useNavigate } from "react-router-dom";

function Support() {
    const [fullName, setFullName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [success, setSuccess] = useState(false);

    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!fullName || !email || !message) return;

        // اینجا می‌تونی API بزنی
        console.log({ fullName, email, message });

        setSuccess(true);

        setTimeout(() => {
            setSuccess(false);
            setFullName("");
            setEmail("");
            setMessage("");
        }, 2000);
    };

    const handleBack = () => {
        navigate(-1);
    };

    return (
        <>
            <div className="bg-garyLight h-screen flex justify-center items-center">

                <div className="bg-white w-7/12 h-4/6 rounded-2xl shadow flex flex-row-reverse overflow-hidden">

                    {/* RIGHT SIDE BRANDING */}
                    <div className="bg-purpleLight w-1/2 flex flex-col items-center justify-center rounded-r-2xl">
                        <p className="t-purpleDark text-2xl font-black mb-4">
                            پشتیبانی بوستان
                        </p>
                        <p className="text-slate-400 text-xs mb-8 text-center px-6">
                            سوالات و مشکلات خود را برای ما ارسال کنید
                        </p>
                        <img
                            src="/image/BoostanLogo.png"
                            className="w-3/4 mb-10"
                            alt="logo"
                        />

                        <button
                            onClick={handleBack}
                            className="bg-white text-purpleDark px-6 py-2 rounded mt-4"
                        >
                            بازگشت
                        </button>
                    </div>

                    {/* LEFT SIDE FORM */}
                    <form
                        onSubmit={handleSubmit}
                        dir="rtl"
                        className="w-1/2 flex flex-col items-center justify-center"
                    >
                        <img src="/image/Logo.png" className="w-12" />

                        <p className="t-purpleDark font-extrabold text-lg my-4">
                            تماس با پشتیبانی
                        </p>

                        <p className="text-slate-400 text-xs mb-8 text-center w-3/4">
                            لطفاً اطلاعات خود و پیام را وارد کنید
                        </p>

                        <input
                            type="text"
                            placeholder="نام و نام خانوادگی"
                            className="w-4/6 border rounded px-3 py-2 mb-3"
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                        />

                        <input
                            type="email"
                            placeholder="ایمیل"
                            className="w-4/6 border rounded px-3 py-2 mb-3"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />

                        <textarea
                            placeholder="متن پیام..."
                            className="w-4/6 border rounded px-3 py-2 mb-4 h-28 resize-none"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                        />

                        <button
                            type="submit"
                            className="bg-purpleDark text-white w-4/6 py-3 rounded mt-2"
                        >
                            ارسال پیام
                        </button>

                        {success && (
                            <p className="text-green-600 text-xs mt-3">
                                پیام با موفقیت ارسال شد ✔
                            </p>
                        )}
                    </form>
                </div>
            </div>
        </>
    );
}

export default Support;